import { useQuery } from "@tanstack/react-query";
import { tournamentApi } from "@bw/shared/api";
import type { Schema } from "@bw/shared/types/generated";

import { queryKeys } from "../../../common/query/queryClient";

/**
 * Public availability metadata for the immutable official report. It remains
 * separate from the archive receipt because an operator explicitly releases it
 * after publication; a historical archive without that release has no report.
 */
export function useTournamentArchiveRelease(
  tournamentId: string,
  enabled: boolean,
) {
  return useQuery<Schema["TournamentPublicArchiveReleaseResponse"]>({
    queryKey: queryKeys.tournaments.archiveRelease(tournamentId),
    queryFn: () => tournamentApi.getPublicArchiveRelease(tournamentId),
    enabled: enabled && Boolean(tournamentId),
  });
}
